module.exports = __webpack_public_path__ + "static/media/AvenirNext300.0d811d6a.woff";